
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl",
      function () {
        return require("private-next-pages/nl/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl"])
      });
    }
  